import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport';
import BaseComponent from '../lib/BaseComponent';

export class HeaderComponent extends BaseComponent {

    init() {
      this.isOpen = false;

      this.shader = $(this.el).find('[data-menu-shader]');
      this.wrapper = $(this.el).find('[data-menu-wrapper]');
      this.menu = $(this.el).find('[data-menu]');
      this.searchField = this.wrapper.find('[data-menu-field]');
      this.btnOpen = $(this.el).find('[data-menu-open]');
      this.hamburgerTop = this.btnOpen.find('i:nth-of-type(1)');
      this.hamburgerMiddle = this.btnOpen.find('i:nth-of-type(2)');
      this.hamburgerBottom = this.btnOpen.find('i:nth-of-type(3)');
      this.btnClose = $(this.el).find('[data-menu-close]');
      this.backgrounds = $(this.el).find('[data-menu-background], [data-menu-bar]');

      this.btnOpen.on('click', this.toggle.bind(this));
      this.shader.on('click', this.close.bind(this));
      this.keyupHandler = this.keyup.bind(this);
    }

    keyup(e) {
      const key = e.keyCode || e.which;
      if (this.isOpen && key === 27) {
        this.close();
      }
    }

    toggle(e) {
      e.preventDefault();
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    }

    hamburgerToX() {
      this.btnOpen.attr('aria-label', 'Skjul meny');
      const self = this;
      const offset = parseInt(this.hamburgerTop.css('margin-bottom'), 10) + parseInt(this.hamburgerTop.css('height'), 10);
      TweenLite.to(this.hamburgerTop.nodes, 0.2, {y: offset, ease:'Sine.easeIn'});
      TweenLite.to(this.hamburgerBottom.nodes, 0.2, {y: offset*-1, ease:'Sine.easeIn', onComplete:function(){
        self.hamburgerMiddle.css('opacity', 0);
        TweenLite.to(self.hamburgerTop.nodes, 0.3, {rotationZ: '45deg', ease: 'Quart.easeOut'});
        TweenLite.to(self.hamburgerBottom.nodes, 0.3, {rotationZ: '-45deg', ease: 'Quart.easeOut'});
      }});
    }

    xToHamburger() {
      const self = this;
      this.btnOpen.attr('aria-label', 'Vis meny');
      TweenLite.to(this.hamburgerTop.nodes, 0.1, {rotationZ: '0deg', ease: 'Sine.easeIn'});
      TweenLite.to(this.hamburgerBottom.nodes, 0.1, {rotationZ: '0deg', ease: 'Sine.easeIn', onComplete:function(){
        self.hamburgerMiddle.css('opacity', 1);
        TweenLite.to(self.hamburgerTop.nodes, 0.2, {y: 0, ease: 'Quart.easeOut', clearProps:'all'});
        TweenLite.to(self.hamburgerBottom.nodes, 0.2, {y: 0, ease: 'Quart.easeOut', clearProps:'all'});
      }});
    }

    open() {
      console.log('open');
      this.isOpen = true;

      this.hamburgerToX();

      TweenLite.set(this.backgrounds.nodes, {x:'-100%'});
      TweenLite.set(this.shader.get(0), {opacity:0});
      TweenLite.set(this.wrapper.get(0), {opacity:0, x: -30});
      TweenLite.set(this.menu.get(0), {display:'block'});

      TweenLite.to(this.shader.get(0), 0.3, {opacity:0.5, ease: 'Circ.easeOut'});

      TweenLite.to(this.backgrounds.nodes, 0.3, {x:'0%', ease: 'Circ.easeOut'});

      TweenLite.to(this.wrapper.nodes, 1.5, {delay: 0.15, x:0, ease: 'Expo.easeOut'});
      TweenLite.to(this.wrapper.nodes, 0.5, {delay: 0.15, opacity:1, ease: 'Sine.easeInOut'});

      Viewport.lockTabbing(this.el, this.searchField);
      document.addEventListener('keyup', this.keyupHandler);
    }

    close() {
      const self = this;
      this.isOpen = false;

      this.xToHamburger();

      TweenLite.to(this.wrapper.nodes, 0.1, {opacity:0, ease: 'Circ.easeOut'});
      TweenLite.to(this.shader.get(0), 0.25, {opacity:0, ease: 'Circ.easeOut'});
      TweenLite.to(this.backgrounds.nodes, 0.25, {x:'-100%', ease: 'Circ.easeOut', onComplete:function(){
        self.menu.attr('style', null);
      }});

      Viewport.releaseTabbing(this.btnOpen);
      document.removeEventListener('keyup', this.keyupHandler);
    }

    destroy() {
      this.btnOpen.off('click');
      this.shader.off('click');
      Viewport.releaseTabbing();
      document.removeEventListener('keyup', this.keyupHandler);
    }

}

export default HeaderComponent;



// WEBPACK FOOTER //
// ./src/js/components/Header.js